import { useTemplateStatus } from './useTemplateStatus';
import { useGetCalculationConfigurationQuery } from '../apis/apiGlobalConfiguration';
import { useTemplateOrCalculationWithValue } from './useTemplateOrCalculationWithValue';

/**
 * Hook to determine if the configuration for the current template is editable.
 * The current calculation must be of type 'Template', template status must be editable,
 * and the template must not be locked.
 */
const useIsConfigurationEditable = (): boolean => {
  const templateOrCalculation = useTemplateOrCalculationWithValue();
  const templateStatusInfo = useTemplateStatus();
  const { data: calculationConfig, isFetching: isCalculationConfigFetching } =
    useGetCalculationConfigurationQuery(templateOrCalculation.value);

  if (!templateOrCalculation.hasValidValue) {
    return false;
  }

  if (templateOrCalculation.type === 'Calculation') {
    return false;
  } else {
    if (!templateStatusInfo.isEditable) {
      return false;
    }

    if (!isCalculationConfigFetching && calculationConfig) {
      if (calculationConfig.isLocked) {
        return false;
      }
    }

    return true;
  }
};

export default useIsConfigurationEditable;
